import { render, staticRenderFns } from "./vgpInputSwitch.vue?vue&type=template&id=73bb36ec&"
import script from "./vgpInputSwitch.vue?vue&type=script&lang=js&"
export * from "./vgpInputSwitch.vue?vue&type=script&lang=js&"
import style0 from "./vInput.less?vue&type=style&index=0&module=true&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./vInput.less?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./vInput.less?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("73bb36ec")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bb36ec')) {
      api.createRecord('73bb36ec', component.options)
    } else {
      api.reload('73bb36ec', component.options)
    }
    module.hot.accept("./vgpInputSwitch.vue?vue&type=template&id=73bb36ec&", function () {
      api.rerender('73bb36ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/VueComponents/vInput/vgpInputSwitch.vue"
export default component.exports